<template>
  <div class="product-counter" :disabled="loading">
    <span class="product-counter__sign product-counter__sign--minus" :class="{'product-counter__sign--disabled' : purchase.amount === 1}" @click="decrement_product_count">
      <svg-icon icon="minus"></svg-icon>
    </span>
    <span class="product-counter__counter">{{purchase.product.per_item_key === 'weight-based' ? `${PER_ITEM_WEIGHT * purchase.amount} г` : `${purchase.amount} шт.`}}</span>
    <span class="product-counter__sign product-counter__sign--plus" @click="increment_product_count">
      <svg-icon icon="plus"></svg-icon>
    </span>
  </div>
</template>

<script>
  import API from '@MAIN/app/api'
  import Analytics from '../../../modules/Analytics.js'

  export default {
    props : ['purchase'],
    data() {
      return {
        loading : false,
        cart : window.CART_FULL,
        PER_ITEM_WEIGHT: window.PER_ITEM_WEIGHT,
      }
    },
    computed : {

    },
    methods: {
      increment_product_count() {
        if (this.purchase.real_amount > 999) {
          return
        }
        this.change_product_count(this.purchase, parseInt(this.purchase.real_amount) + 1)

        Analytics.addToCart(this.purchase.product)
      },
      decrement_product_count() {
        if (this.purchase.real_amount < 2)
          return

        this.change_product_count(this.purchase, parseInt(this.purchase.real_amount) - 1)

        Analytics.removeFromCart(this.purchase.product)
      },
      updateCart(new_cart) {
        Object.assign(this.cart, new_cart)
      },
      async change_product_count(purchase, newAmount) {
        if (this.$parent.loading) {
          return
        }

        this.$parent.loading = true

        const cart = await API.cart.update_amount(purchase.purchase_idx, newAmount)

        this.$parent.loading = false

        this.updateCart(cart)
      }
    },
    mounted() {

    },
    components: {

    },
    watch : {

    }
  }
</script>
